export const SET_EXTENSIONS = 'SET_EXTENSIONS'
export const SET_EXTENSIONS_SSO = 'SET_EXTENSIONS_SSO'
export const RESET_EXTENSIONS = 'RESET_EXTENSIONS'
